import { api } from "./api.js";

/** GET /api/settings/location — salon geofence + office hours. */
export const getLocation = () => api.get("/settings/location");

/** PUT /api/settings/location (admin) */
export const updateLocation = (payload) => api.put("/settings/location", payload);

/** GET /api/settings/reminder — salon-wide default reminder offset. */
export const getReminder = () => api.get("/settings/reminder");

/** PUT /api/settings/reminder (admin) — body `{ offsetMinutes: 15 | 30 | 60 }`. */
export const updateReminder = (offsetMinutes) =>
  api.put("/settings/reminder", { offsetMinutes });

export default {
  getLocation,
  updateLocation,
  getReminder,
  updateReminder,
};
